import { Helmet } from 'react-helmet-async';
import { ForSuppliersView } from 'src/sections/for-suppliers/view';

export default function ForSuppliersPage() {
  return (
    <>
      <Helmet>
        <title>For Suppliers - Cartify</title>
      </Helmet>
      <ForSuppliersView />
    </>
  );
}
